/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PromptReports } from './PromptReports';
import {
    PromptReportsFromJSON,
    PromptReportsFromJSONTyped,
    PromptReportsToJSON,
} from './PromptReports';

/**
 * 
 * @export
 * @interface GetPromptReportsResponseContent
 */
export interface GetPromptReportsResponseContent {
    /**
     * 
     * @type {PromptReports}
     * @memberof GetPromptReportsResponseContent
     */
    reports: PromptReports;
}


/**
 * Check if a given object implements the GetPromptReportsResponseContent interface.
 */
export function instanceOfGetPromptReportsResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reports" in value;

    return isInstance;
}

export function GetPromptReportsResponseContentFromJSON(json: any): GetPromptReportsResponseContent {
    return GetPromptReportsResponseContentFromJSONTyped(json, false);
}

export function GetPromptReportsResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromptReportsResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reports': PromptReportsFromJSON(json['reports']),
    };
}

export function GetPromptReportsResponseContentToJSON(value?: GetPromptReportsResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reports': PromptReportsToJSON(value.reports),
    };
}

